import React from "react";


function ExternalLinkIcon() {
    return (
        <svg fill="#000000" width="21" height="21" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path d="M7.27,12H8.78V10.55H7.27ZM9.92,4.58h0A3.36,3.36,0,0,0,7.9,4a2.82,2.82,0,0,0-1.55.41A2.49,2.49,0,0,0,5.28,6.58H6.83a1.55,1.55,0,0,1,.26-.86A.93.93,0,0,1,8,5.31a1,1,0,0,1,.87.33,1.26,1.26,0,0,1,.24.75A1.17,1.17,0,0,1,8.87,7a1.34,1.34,0,0,1-.32.31l-.39.31a2.19,2.19,0,0,0-.71.8,4.39,4.39,0,0,0-.18,1.25H8.73a2.22,2.22,0,0,1,.07-.63,1.18,1.18,0,0,1,.41-.57l.38-.29a3.66,3.66,0,0,0,.78-.74,1.93,1.93,0,0,0,.35-1.18A2,2,0,0,0,9.92,4.58Zm3-1.53A7,7,0,1,0,13,13,7,7,0,0,0,13,3.05ZM12,12A5.6,5.6,0,0,1,4,12,5.61,5.61,0,0,1,4,4,5.6,5.6,0,0,1,12,4,5.61,5.61,0,0,1,12,12Z"/>
            </g>
        </svg>
    );
}

export default ExternalLinkIcon;
